import Vue from 'vue'
import Moment from 'moment'
import VueFormWizard from 'vue-form-wizard'
import Swal from 'sweetalert2'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import dateUtil from 'element-ui/lib/utils/date';
import money from 'v-money';
import VueNumeric from 'vue-numeric'
import VueTabs from 'vue-nav-tabs'
import PSwitch from 'src/components/UIComponents/Switch.vue';

import Formatacao from '@/services/Formatacao'
import Mensagens from '@/services/Mensagens'
import API from '@/services/API'
import Assinatura from '@/services/Assinatura'
import Armazenamento from '@/services/Armazenamento'
import Compartilhamento from '@/services/Compartilhamento'

Vue.use(ElementUI);
Vue.use(money);
Vue.use(VueNumeric);
Vue.use(VueFormWizard);
Vue.use(VueTabs)

export default {
  name: 'ConfinamentoSimplesCtrl',
  components: {
    PSwitch,
    money
  },
  props: [ 'novo' ],
  data () {
    return {
      compartilhado: {
        assinatura: Compartilhamento.assinatura.dados
      },
      nome: '',
      resultDone: false,
      quantidadeDiariasArracoamento: '',
      valorDoGadoRCabeca: '',
      dataD1Arracoamento: '',
      precoVendaBruto: '',
      custoOperacionalCabDia: '',
      custoDeMedicamentosOutrosCAB: '',
      custoDeNutricaoDiarioMedioCABdia: '',
      GMDKgD: '',
      pesoMedioEntradaKgCabBaseOrigem: '',
      rendimentoDeCarcacaDaEntrada: '',
      rendimentoDeCarcacaDoAbate: '',
      loading: false,
      descricoes: null,
      estagioNegocioOpcoes: [{
        value: 'treinamento',
        label: 'Treinamento'
      }, {
        value: 'orcamento',
        label: 'Orçamento'
      }, {
        value: 'inicioOperacao',
        label: 'Início de Operação'
      }, {
        value: 'encerramentoOperacao',
        label: 'Encerramento de Operação'
      }],
      estagioNegocio: '',
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      },
      precision2: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },
      precision3: {
        decimal: ',',
        thousands: '.',
        precision: 3,
        masked: false
      },
      resultados: {}
    }
  },
  methods: {
    isMobile() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
  },
    clear(event) {
      event.target.value=''
    },
    showMessage (message) {
      if (message !== null && message !== '') {
        Swal({
          title: message,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
      }
    },
    showMissingAnswerMessage () {
      Swal({
        title: 'Por favor, preencha todos os campos obrigatórios marcados com *.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill'
      });
    },
    showMissingAnswerMessageWithParams (params) {
      Swal({
        title: 'Por favor, preencha os campos: ' + params + '.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success btn-fill'
      });
    },
    novaSimulacaoBaseada () {
      let card = document.getElementsByClassName('card');
      for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
        card[0].getElementsByTagName('input')[i].disabled = false;
      }
      this.resultDone = false;
      this.$refs.wizard.changeTab(1, 0);
    },
    reload () {
      location.reload();
    },
    getInitialValues () {
      const descricoes = API.listar.descricoes()
      return Promise.all([descricoes])
    },
    validateProdutivas () {
      if (this.nome !== '' && this.nome !== null &&
      this.pesoMedioEntradaKgCabBaseOrigem !== '' && this.pesoMedioEntradaKgCabBaseOrigem !== null &&
      this.quantidadeDiariasArracoamento !== '' && this.quantidadeDiariasArracoamento !== null &&
      this.GMDKgD !== '' && this.GMDKgD !== null && this.GMDKgD !== '0,000' &&
      this.rendimentoDeCarcacaDaEntrada !== '' && this.rendimentoDeCarcacaDaEntrada !== null && this.rendimentoDeCarcacaDaEntrada !== '0,000' &&
      this.rendimentoDeCarcacaDoAbate !== '' && this.rendimentoDeCarcacaDoAbate !== null && this.rendimentoDeCarcacaDoAbate !== '0,000' &&
      this.nome !== '' && this.nome !== null &&
      this.estagioNegocio !== null && this.estagioNegocio !== '') {
        return true
      }
      Mensagens.showMissingAnswerMessage();
      return false
    },
    getSimulation () {
      let id = this.$router.history.current.params.id
      if (id) {
        API.simulacao.buscar(id)
          .then(response => {
            if (response.status === 200) {
              this.resultados = response.data.simulacao.simulacao_saida.dados.resultados;
              let entrada = response.data.simulacao.simulacao_entrada.dados;
              console.log(this.resultados);
              this.resultDone = true;
              this.handleInput(entrada);
              this.$refs.wizard.changeTab(0, 1);
              this.$refs.wizard.changeTab(1, 2);
            } else {
              console.log(' #getSimulation (then -> else) Algo deu errado, recarregue a página');
            }
          })
          .catch(e => {
            console.error(' #getSimulation (catch) Algo deu errado, recarregue a página');
            console.error(e);
            this.$router.push({
              name: 'confinamento-basico-criar'
            }, window && window.location && window.location.reload());
          })
      }
    },
    handleInput (entrada) {
      let card = document.getElementsByClassName('card');
      for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
        card[0].getElementsByTagName('input')[i].disabled = true;
      }
      this.nome = entrada.nome;
      this.pesoMedioEntradaKgCabBaseOrigem = entrada.pesoMedioEntradaKgCabBaseOrigem
      this.quantidadeDiariasArracoamento = entrada.quantidadeDiariasArracoamento
      this.dataD1Arracoamento = Moment(entrada.dataD1Arracoamento, 'DD/MM/YYYY').toDate();
      this.GMDKgD = entrada.GMDKgD;
      this.rendimentoDeCarcacaDaEntrada = entrada.rendimentoDeCarcacaDaEntrada
      this.rendimentoDeCarcacaDoAbate = entrada.rendimentoDeCarcacaDoAbate
      this.estagioNegocio = entrada.estagioNegocio;
      this.valorDoGadoRCabeca = entrada.valorDoGadoRCabeca;
      this.custoOperacionalCabDia = entrada.custoOperacionalCabDia;
      this.custoDeNutricaoDiarioMedioCABdia = entrada.custoDeNutricaoDiarioMedioCABdia;
      this.precoVendaBruto = entrada.precoVendaBruto;
      this.custoDeMedicamentosOutrosCAB = entrada.custoDeMedicamentosOutrosCAB;
    },
    calcular () {
      return API.simulacao.calcular.confinamento.basico({
        nome: this.nome,
        pesoMedioEntradaKgCabBaseOrigem: Formatacao.converterStringParaNumero(this.pesoMedioEntradaKgCabBaseOrigem),
        quantidadeDiariasArracoamento: Formatacao.converterStringParaNumero(this.quantidadeDiariasArracoamento),
        GMDKgD: Formatacao.converterStringParaNumero(this.GMDKgD),
        dataD1Arracoamento: dateUtil.format(this.dataD1Arracoamento, 'dd/MM/yyyy'),
        valorDoGadoRCabeca: Formatacao.converterStringParaNumero(this.valorDoGadoRCabeca),
        precoVendaBruto: Formatacao.converterStringParaNumero(this.precoVendaBruto),
        custoOperacionalCabDia: Formatacao.converterStringParaNumero(this.custoOperacionalCabDia),
        custoDeNutricaoDiarioMedioCABdia: Formatacao.converterStringParaNumero(this.custoDeNutricaoDiarioMedioCABdia),
        custoDeMedicamentosOutrosCAB: Formatacao.converterStringParaNumero(this.custoDeMedicamentosOutrosCAB),
        rendimentoDeCarcacaDaEntrada: Formatacao.converterStringParaNumero(this.rendimentoDeCarcacaDaEntrada),
        rendimentoDeCarcacaDoAbate: Formatacao.converterStringParaNumero(this.rendimentoDeCarcacaDoAbate),
        estagioNegocio: this.estagioNegocio
      })
    },
    buscaResultados () {
      if (this.resultDone) {
        return true;
      }
      if (this.dataD1Arracoamento === '' || this.dataD1Arracoamento == null || this.precoVendaBruto == null || this.precoVendaBruto === '0,00') {
        Mensagens.showMissingAnswerMessage();
        return false;
      } else {
        if (this.dataD1Arracoamento === '' || this.dataD1Arracoamento === null) {
          this.dataD1Arracoamento = Date()
        }
        Swal.queue([{
          title: 'Executar simulação?',
          confirmButtonText: 'Confirmar',
          text: 'Você deseja executar sua simulação com os dados preenchidos? ',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return this.calcular()
              .then(response => {
                if (response.status === 200) {
                  this.resultados = response.data.resultados
                  Armazenamento.quantidadeSimulacoes.gravar({ quantidade: response.data.total })
                  Assinatura.atualizar()
                  let card = document.getElementsByClassName('card');
                  for (let i = 0; i < card[0].getElementsByTagName('input').length; i++) {
                    card[0].getElementsByTagName('input')[i].disabled = true;
                  }
                  this.resultDone = true;
                  this.$refs.wizard.changeTab(1, 2);
                  return true;
                } else {
                  this.$refs.wizard.changeTab(2, 1);
                  return false;
                }
              })
              .catch(e => {
                this.$refs.wizard.changeTab(2, 1);
                return false;
              })
          }
        }]).catch(Swal.noop)
      }
    }
  },
  created () {
    // Direcionar para assinatura
    if (this.novo && !this.compartilhado.assinatura.permitirNovaSimulacao) {
      return this.$router.push({
        name: 'meu-perfil'
      })
    }
    this.loading = true
    this.getInitialValues().then(([descricoes]) => {
      this.loading = false
      this.descricoes = descricoes;
      return this.getSimulation();
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Confinamento/SimplesCtrl.js